import { render, staticRenderFns } from "./sidemenu.vue?vue&type=template&id=0424030c&scoped=true&"
import script from "./sidemenu.vue?vue&type=script&lang=js&"
export * from "./sidemenu.vue?vue&type=script&lang=js&"
import style0 from "./sidemenu.vue?vue&type=style&index=0&id=0424030c&prod&lang=scss&"
import style1 from "./sidemenu.vue?vue&type=style&index=1&id=0424030c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0424030c",
  null
  
)

export default component.exports